import './Navbar.css';
import {Outlet, Link } from "react-router-dom";

const NavLinks = ({isClicked, closeMenu}) =>{
    const scrollToTop = () => {
    window.scrollTo(0, 0)
    }
    return(
        <>
            <nav className="NavLinks">
                <ul>
                    <li onClick={() => isClicked && closeMenu() && scrollToTop()}>
                        <Link className='nav-links' to="/">Accueil</Link>
                    </li>
                    {/* <li onClick={() => isClicked && closeMenu()}>
                        <Link to="/services">Services</Link>
                    </li> */}
                    <li onClick={() => isClicked && closeMenu()}>
                        <Link className='nav-links' to="/team">L'équipe</Link>
                    </li>
                    {/* <li onClick={() => isClicked && closeMenu()}>
                        <a href="/cards">TestCards</a>
                    </li> */}
                    <li onClick={() => isClicked && closeMenu()}>
                        <Link className='nav-links' to="/contact">Nous Contacter</Link>
                    </li>
                </ul>
            </nav>
            
           
        </>
    )
}

export default NavLinks;